import { sideNavHeader } from './side-nav'

export function AccountSideNav() {
  return (
    <>
      <div data-cy='side-nav-account' className={sideNavHeader}></div>
    </>
  )
}
